import { render, staticRenderFns } from "./MetaMaskOffer.vue?vue&type=template&id=78078f65&scoped=true&"
import script from "./MetaMaskOffer.vue?vue&type=script&lang=js&"
export * from "./MetaMaskOffer.vue?vue&type=script&lang=js&"
import style0 from "./MetaMaskOffer.vue?vue&type=style&index=0&id=78078f65&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78078f65",
  null
  
)

export default component.exports